import React from 'react';
import { Section } from '@atlaskit/side-navigation';
import { ForgeScreenEvent } from '@atlassian/jira-forge-ui-analytics/src/common/ui/index.tsx';
import { TriggerAnalyticsWrapper } from '@atlassian/jira-forge-ui-analytics/src/ui/servicedesk-queue-page/index.tsx';
import { SERVICEDESK_QUEUE_PAGE_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import type { ServiceDeskQueuePage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { ForgeItem } from '../../common/ui/forge-item/index.tsx';
import { toSections } from '../../common/utils/subpages/index.tsx';
import { useServiceDeskQueueForgeApps } from '../../controllers/servicedesk-queue/index.tsx';
import { messages } from './messages.tsx';

export const getItemHref = (extension: ServiceDeskQueuePage, projectKey: string) => {
	const { appId, envId } = parseExtensionId(extension.id);
	return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ForgeServiceDeskQueueSection: Flow.AbstractComponent<Record<any, any>> = () => {
	const { data } = useServiceDeskQueueForgeApps();
	const { data: projectContextData } = useProjectContext();
	const { formatMessage } = useIntl();

	if (!data?.length || !projectContextData) return null;

	const { projectKey } = projectContextData;

	return (
		<Section title={formatMessage(messages.forgeSectionTitle)}>
			{data.map((extension) => (
				<ForgeItem
					key={extension.id}
					id={extension.id}
					environmentType={extension.environmentType}
					environmentKey={extension.environmentKey}
					url={getItemHref(extension, projectKey)}
					name={extension.properties.title}
					sections={toSections(extension)}
					moduleName={SERVICEDESK_QUEUE_PAGE_MODULE}
					iconUrl={extension.properties.icon}
					showIcon
				/>
			))}
			<ForgeScreenEvent
				attributes={{
					moduleType: SERVICEDESK_QUEUE_PAGE_MODULE,
				}}
			/>
		</Section>
	);
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<TriggerAnalyticsWrapper>
		<ForgeServiceDeskQueueSection />
	</TriggerAnalyticsWrapper>
);
